import e from"./Icon.vue.js";var r={components:{Icon:e},props:{refIndex:{required:!0,type:[Number,String]},modalTitle:{required:!1,type:String,default:null}},data:()=>({open:!1})};export{r as default};
